export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <path d="M20 13V34.6667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 7.16663H15.8333C18.1345 7.16663 20 9.03211 20 11.3333V13.8333H15C13.159 13.8333 11.6667 12.3409 11.6667 10.5C11.6667 8.65901 13.159 7.16663 15 7.16663Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25 7.16663H24.1667C21.8655 7.16663 20 9.03211 20 11.3333V13.8333H25C26.841 13.8333 28.3333 12.3409 28.3333 10.5C28.3333 8.65901 26.841 7.16663 25 7.16663Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33334 20.5H31.6667V33.8333C31.6667 34.7538 30.9205 35.5 30 35.5H10C9.07954 35.5 8.33334 34.7538 8.33334 33.8333V20.5Z"
                stroke="white"
                strokeWidth="2"
            />
            <rect width="30" height="6.66667" rx="1.66667" transform="matrix(1 0 0 -1 5 20.5)" stroke="white" strokeWidth="2" />
        </svg>
    );
}
